import {Country} from '../types/location.types';

const countries: Country[] = [
    {
        countryCode: "US",
        countryName: "United States",
        nativeName: "ᏌᏊ ᎢᏳᎾᎵᏍᏔᏅ ᏍᎦᏚᎩ"
    },
    {
        countryCode: "CA",
        countryName: "Canada",
        nativeName: "Canada"
    },
    {
        countryCode: "MX",
        countryName: "Mexico",
        nativeName: "México"
    },
    {
        countryCode: "PR",
        countryName: "Puerto Rico",
        nativeName: "Puerto Rico"
    },
    {
        countryCode: "VI",
        countryName: "U.S. Virgin Islands",
        nativeName: "U.S. Virgin Islands"
    },
    {
        countryCode: "AF",
        countryName: "Afghanistan",
        nativeName: "افغانستان"
    },
    {
        countryCode: "AX",
        countryName: "Åland Islands",
        nativeName: "Åland"
    },
    {
        countryCode: "AL",
        countryName: "Albania",
        nativeName: "Shqipëri"
    },
    {
        countryCode: "DZ",
        countryName: "Algeria",
        nativeName: "الجزائر"
    },
    {
        countryCode: "AO",
        countryName: "Angola",
        nativeName: "Angóla"
    },
    {
        countryCode: "AR",
        countryName: "Argentina",
        nativeName: "Argentina"
    },
    {
        countryCode: "AM",
        countryName: "Armenia",
        nativeName: "Հայաստան"
    },
    {
        countryCode: "AT",
        countryName: "Austria",
        nativeName: "Österreich"
    },
    {
        countryCode: "AZ",
        countryName: "Azerbaijan",
        nativeName: "Азәрбајҹан"
    },
    {
        countryCode: "BH",
        countryName: "Bahrain",
        nativeName: "البحرين"
    },
    {
        countryCode: "BD",
        countryName: "Bangladesh",
        nativeName: "বাংলাদেশ"
    },
    {
        countryCode: "BY",
        countryName: "Belarus",
        nativeName: "Беларусь"
    },
    {
        countryCode: "BE",
        countryName: "Belgium",
        nativeName: "Belgien"
    },
    {
        countryCode: "BZ",
        countryName: "Belize",
        nativeName: "Belice"
    },
    {
        countryCode: "BJ",
        countryName: "Benin",
        nativeName: "Bénin"
    },
    {
        countryCode: "BT",
        countryName: "Bhutan",
        nativeName: "འབྲུག"
    },
    {
        countryCode: "BA",
        countryName: "Bosnia & Herzegovina",
        nativeName: "Босна и Херцеговина"
    },
    {
        countryCode: "BR",
        countryName: "Brazil",
        nativeName: "Brasil"
    },
    {
        countryCode: "BG",
        countryName: "Bulgaria",
        nativeName: "България"
    },
    {
        countryCode: "BF",
        countryName: "Burkina Faso",
        nativeName: "𞤄𞤵𞤪𞤳𞤭𞤲𞤢 𞤊𞤢𞤧𞤮𞥅"
    },
    {
        countryCode: "BI",
        countryName: "Burundi",
        nativeName: "Uburundi"
    },
    {
        countryCode: "KH",
        countryName: "Cambodia",
        nativeName: "កម្ពុជា"
    },
    {
        countryCode: "CM",
        countryName: "Cameroon",
        nativeName: "Kàmàlûŋ"
    },
    {
        countryCode: "IC",
        countryName: "Canary Islands",
        nativeName: "Canarias"
    },
    {
        countryCode: "CV",
        countryName: "Cape Verde",
        nativeName: "Kabu Verdi"
    },
    {
        countryCode: "BQ",
        countryName: "Caribbean Netherlands",
        nativeName: "Caribisch Nederland"
    },
    {
        countryCode: "CF",
        countryName: "Central African Republic",
        nativeName: "République centrafricaine"
    },
    {
        countryCode: "EA",
        countryName: "Ceuta & Melilla",
        nativeName: "Ceuta y Melilla"
    },
    {
        countryCode: "TD",
        countryName: "Chad",
        nativeName: "تشاد"
    },
    {
        countryCode: "CN",
        countryName: "China",
        nativeName: "རྒྱ་ནག"
    },
    {
        countryCode: "CO",
        countryName: "Colombia",
        nativeName: "Kurũbiya"
    },
    {
        countryCode: "KM",
        countryName: "Comoros",
        nativeName: "جزر القمر"
    },
    {
        countryCode: "CG",
        countryName: "Congo - Brazzaville",
        nativeName: "Congo-Brazzaville"
    },
    {
        countryCode: "CD",
        countryName: "Congo - Kinshasa",
        nativeName: "Congo-Kinshasa"
    },
    {
        countryCode: "HR",
        countryName: "Croatia",
        nativeName: "Hrvatska"
    },
    {
        countryCode: "CY",
        countryName: "Cyprus",
        nativeName: "Κύπρος"
    },
    {
        countryCode: "CZ",
        countryName: "Czechia",
        nativeName: "Česko"
    },
    {
        countryCode: "DK",
        countryName: "Denmark",
        nativeName: "Danmark"
    },
    {
        countryCode: "DJ",
        countryName: "Djibouti",
        nativeName: "جيبوتي"
    },
    {
        countryCode: "DO",
        countryName: "Dominican Republic",
        nativeName: "República Dominicana"
    },
    {
        countryCode: "EG",
        countryName: "Egypt",
        nativeName: "مصر"
    },
    {
        countryCode: "GQ",
        countryName: "Equatorial Guinea",
        nativeName: "Guinea Ecuatorial"
    },
    {
        countryCode: "ER",
        countryName: "Eritrea",
        nativeName: "إريتريا"
    },
    {
        countryCode: "EE",
        countryName: "Estonia",
        nativeName: "Eesti"
    },
    {
        countryCode: "ET",
        countryName: "Ethiopia",
        nativeName: "ኢትዮጵያ"
    },
    {
        countryCode: "FO",
        countryName: "Faroe Islands",
        nativeName: "Føroyar"
    },
    {
        countryCode: "FI",
        countryName: "Finland",
        nativeName: "Suomi"
    },
    {
        countryCode: "FR",
        countryName: "France",
        nativeName: "Frañs"
    },
    {
        countryCode: "GF",
        countryName: "French Guiana",
        nativeName: "Guyane française"
    },
    {
        countryCode: "PF",
        countryName: "French Polynesia",
        nativeName: "Polynésie française"
    },
    {
        countryCode: "GM",
        countryName: "Gambia",
        nativeName: "𞤘𞤢𞤥𞤦𞤭𞤴𞤢"
    },
    {
        countryCode: "GE",
        countryName: "Georgia",
        nativeName: "საქართველო"
    },
    {
        countryCode: "DE",
        countryName: "Germany",
        nativeName: "Deutschland"
    },
    {
        countryCode: "GH",
        countryName: "Ghana",
        nativeName: "Gaana"
    },
    {
        countryCode: "GR",
        countryName: "Greece",
        nativeName: "Ελλάδα"
    },
    {
        countryCode: "GL",
        countryName: "Greenland",
        nativeName: "Grønland"
    },
    {
        countryCode: "GN",
        countryName: "Guinea",
        nativeName: "𞤘𞤭𞤲𞤫"
    },
    {
        countryCode: "GW",
        countryName: "Guinea-Bissau",
        nativeName: "𞤘𞤭𞤲𞤫-𞤄𞤭𞤧𞤢𞤱𞤮𞥅"
    },
    {
        countryCode: "HT",
        countryName: "Haiti",
        nativeName: "Haïti"
    },
    {
        countryCode: "HK",
        countryName: "Hong Kong SAR China",
        nativeName: "中華人民共和國香港特別行政區"
    },
    {
        countryCode: "HU",
        countryName: "Hungary",
        nativeName: "Magyarország"
    },
    {
        countryCode: "IS",
        countryName: "Iceland",
        nativeName: "Ísland"
    },
    {
        countryCode: "IN",
        countryName: "India",
        nativeName: "ভাৰত"
    },
    {
        countryCode: "ID",
        countryName: "Indonesia",
        nativeName: "Indonésia"
    },
    {
        countryCode: "IR",
        countryName: "Iran",
        nativeName: "ئێران"
    },
    {
        countryCode: "IQ",
        countryName: "Iraq",
        nativeName: "العراق"
    },
    {
        countryCode: "IE",
        countryName: "Ireland",
        nativeName: "Éire"
    },
    {
        countryCode: "IM",
        countryName: "Isle of Man",
        nativeName: "Ellan Vannin"
    },
    {
        countryCode: "IL",
        countryName: "Israel",
        nativeName: "إسرائيل"
    },
    {
        countryCode: "IT",
        countryName: "Italy",
        nativeName: "Itàlia"
    },
    {
        countryCode: "JP",
        countryName: "Japan",
        nativeName: "日本"
    },
    {
        countryCode: "JO",
        countryName: "Jordan",
        nativeName: "الأردن"
    },
    {
        countryCode: "KZ",
        countryName: "Kazakhstan",
        nativeName: "Қазақстан"
    },
    {
        countryCode: "KE",
        countryName: "Kenya",
        nativeName: "Emetab Kenya"
    },
    {
        countryCode: "XK",
        countryName: "Kosovo",
        nativeName: "Kosovë"
    },
    {
        countryCode: "KW",
        countryName: "Kuwait",
        nativeName: "الكويت"
    },
    {
        countryCode: "KG",
        countryName: "Kyrgyzstan",
        nativeName: "Кыргызстан"
    },
    {
        countryCode: "LA",
        countryName: "Laos",
        nativeName: "ລາວ"
    },
    {
        countryCode: "LV",
        countryName: "Latvia",
        nativeName: "Latvija"
    },
    {
        countryCode: "LB",
        countryName: "Lebanon",
        nativeName: "لبنان"
    },
    {
        countryCode: "LR",
        countryName: "Liberia",
        nativeName: "𞤂𞤢𞤦𞤭𞤪𞤭𞤴𞤢𞥄"
    },
    {
        countryCode: "LY",
        countryName: "Libya",
        nativeName: "ليبيا"
    },
    {
        countryCode: "LI",
        countryName: "Liechtenstein",
        nativeName: "Liächteschtäi"
    },
    {
        countryCode: "LT",
        countryName: "Lithuania",
        nativeName: "Lietuva"
    },
    {
        countryCode: "LU",
        countryName: "Luxembourg",
        nativeName: "Luxemburg"
    },
    {
        countryCode: "MO",
        countryName: "Macao SAR China",
        nativeName: "Macau, RAE da China"
    },
    {
        countryCode: "MG",
        countryName: "Madagascar",
        nativeName: "Madagasikara"
    },
    {
        countryCode: "MY",
        countryName: "Malaysia",
        nativeName: "மலேசியா"
    },
    {
        countryCode: "ML",
        countryName: "Mali",
        nativeName: "Maali"
    },
    {
        countryCode: "MR",
        countryName: "Mauritania",
        nativeName: "موريتانيا"
    },
    {
        countryCode: "MU",
        countryName: "Mauritius",
        nativeName: "Maurice"
    },
    {
        countryCode: "MD",
        countryName: "Moldova",
        nativeName: "Republica Moldova"
    },
    {
        countryCode: "MN",
        countryName: "Mongolia",
        nativeName: "Монгол"
    },
    {
        countryCode: "ME",
        countryName: "Montenegro",
        nativeName: "Црна Гора"
    },
    {
        countryCode: "MA",
        countryName: "Morocco",
        nativeName: "المغرب"
    },
    {
        countryCode: "MZ",
        countryName: "Mozambique",
        nativeName: "Umozambiki"
    },
    {
        countryCode: "MM",
        countryName: "Myanmar (Burma)",
        nativeName: "မြန်မာ"
    },
    {
        countryCode: "NA",
        countryName: "Namibia",
        nativeName: "Namibië"
    },
    {
        countryCode: "NP",
        countryName: "Nepal",
        nativeName: "नेपाल"
    },
    {
        countryCode: "NL",
        countryName: "Netherlands",
        nativeName: "Nederlân"
    },
    {
        countryCode: "NC",
        countryName: "New Caledonia",
        nativeName: "Nouvelle-Calédonie"
    },
    {
        countryCode: "NZ",
        countryName: "New Zealand",
        nativeName: "Aotearoa"
    },
    {
        countryCode: "NE",
        countryName: "Niger",
        nativeName: "Nižer"
    },
    {
        countryCode: "NG",
        countryName: "Nigeria",
        nativeName: "𞤐𞤢𞤶𞤫𞤪𞤭𞤴𞤢𞥄"
    },
    {
        countryCode: "KP",
        countryName: "North Korea",
        nativeName: "조선민주주의인민공화국"
    },
    {
        countryCode: "MK",
        countryName: "North Macedonia",
        nativeName: "Северна Македонија"
    },
    {
        countryCode: "NO",
        countryName: "Norway",
        nativeName: "Norge"
    },
    {
        countryCode: "OM",
        countryName: "Oman",
        nativeName: "عُمان"
    },
    {
        countryCode: "PK",
        countryName: "Pakistan",
        nativeName: "پاکستان"
    },
    {
        countryCode: "PS",
        countryName: "Palestinian Territories",
        nativeName: "الأراضي الفلسطينية"
    },
    {
        countryCode: "PA",
        countryName: "Panama",
        nativeName: "Panamá"
    },
    {
        countryCode: "PE",
        countryName: "Peru",
        nativeName: "Perú"
    },
    {
        countryCode: "PH",
        countryName: "Philippines",
        nativeName: "Pilipinas"
    },
    {
        countryCode: "PL",
        countryName: "Poland",
        nativeName: "Polska"
    },
    {
        countryCode: "QA",
        countryName: "Qatar",
        nativeName: "قطر"
    },
    {
        countryCode: "RE",
        countryName: "Réunion",
        nativeName: "La Réunion"
    },
    {
        countryCode: "RO",
        countryName: "Romania",
        nativeName: "România"
    },
    {
        countryCode: "RU",
        countryName: "Russia",
        nativeName: "Росси"
    },
    {
        countryCode: "RW",
        countryName: "Rwanda",
        nativeName: "U Rwanda"
    },
    {
        countryCode: "ST",
        countryName: "São Tomé & Príncipe",
        nativeName: "São Tomé e Príncipe"
    },
    {
        countryCode: "SA",
        countryName: "Saudi Arabia",
        nativeName: "المملكة العربية السعودية"
    },
    {
        countryCode: "SN",
        countryName: "Senegal",
        nativeName: "𞤅𞤫𞤲𞤫𞤺𞤢𞥄𞤤"
    },
    {
        countryCode: "RS",
        countryName: "Serbia",
        nativeName: "Србија"
    },
    {
        countryCode: "SL",
        countryName: "Sierra Leone",
        nativeName: "𞤅𞤢𞤪𞤢𞤤𞤮𞤲"
    },
    {
        countryCode: "SG",
        countryName: "Singapore",
        nativeName: "Singapura"
    },
    {
        countryCode: "SX",
        countryName: "Sint Maarten",
        nativeName: "Sint-Maarten"
    },
    {
        countryCode: "SK",
        countryName: "Slovakia",
        nativeName: "Slovensko"
    },
    {
        countryCode: "SI",
        countryName: "Slovenia",
        nativeName: "Slovenija"
    },
    {
        countryCode: "SO",
        countryName: "Somalia",
        nativeName: "الصومال"
    },
    {
        countryCode: "ZA",
        countryName: "South Africa",
        nativeName: "Suid-Afrika"
    },
    {
        countryCode: "KR",
        countryName: "South Korea",
        nativeName: "대한민국"
    },
    {
        countryCode: "SS",
        countryName: "South Sudan",
        nativeName: "جنوب السودان"
    },
    {
        countryCode: "ES",
        countryName: "Spain",
        nativeName: "España"
    },
    {
        countryCode: "LK",
        countryName: "Sri Lanka",
        nativeName: "ශ්‍රී ලංකාව"
    },
    {
        countryCode: "BL",
        countryName: "St. Barthélemy",
        nativeName: "Saint-Barthélemy"
    },
    {
        countryCode: "SH",
        countryName: "St. Helena",
        nativeName: "St Helena"
    },
    {
        countryCode: "KN",
        countryName: "St. Kitts & Nevis",
        nativeName: "St Kitts & Nevis"
    },
    {
        countryCode: "LC",
        countryName: "St. Lucia",
        nativeName: "St Lucia"
    },
    {
        countryCode: "MF",
        countryName: "St. Martin",
        nativeName: "Saint-Martin"
    },
    {
        countryCode: "PM",
        countryName: "St. Pierre & Miquelon",
        nativeName: "Saint-Pierre-et-Miquelon"
    },
    {
        countryCode: "VC",
        countryName: "St. Vincent & Grenadines",
        nativeName: "St Vincent & the Grenadines"
    },
    {
        countryCode: "SD",
        countryName: "Sudan",
        nativeName: "السودان"
    },
    {
        countryCode: "SJ",
        countryName: "Svalbard & Jan Mayen",
        nativeName: "Svalbard og Jan Mayen"
    },
    {
        countryCode: "SE",
        countryName: "Sweden",
        nativeName: "Ruoŧŧa"
    },
    {
        countryCode: "CH",
        countryName: "Switzerland",
        nativeName: "Schweiz"
    },
    {
        countryCode: "SY",
        countryName: "Syria",
        nativeName: "سوريا"
    },
    {
        countryCode: "TW",
        countryName: "Taiwan",
        nativeName: "台灣"
    },
    {
        countryCode: "TJ",
        countryName: "Tajikistan",
        nativeName: "Тоҷикистон"
    },
    {
        countryCode: "TZ",
        countryName: "Tanzania",
        nativeName: "Tadhania"
    },
    {
        countryCode: "TH",
        countryName: "Thailand",
        nativeName: "ไทย"
    },
    {
        countryCode: "TG",
        countryName: "Togo",
        nativeName: "Togo nutome"
    },
    {
        countryCode: "TN",
        countryName: "Tunisia",
        nativeName: "تونس"
    },
    {
        countryCode: "TR",
        countryName: "Turkey",
        nativeName: "Tirkiye"
    },
    {
        countryCode: "TM",
        countryName: "Turkmenistan",
        nativeName: "Türkmenistan"
    },
    {
        countryCode: "UG",
        countryName: "Uganda",
        nativeName: "Yuganda"
    },
    {
        countryCode: "UA",
        countryName: "Ukraine",
        nativeName: "Украина"
    },
    {
        countryCode: "AE",
        countryName: "United Arab Emirates",
        nativeName: "الإمارات العربية المتحدة"
    },
    {
        countryCode: "GB",
        countryName: "United Kingdom",
        nativeName: "Y Deyrnas Unedig"
    },
    {
        countryCode: "UZ",
        countryName: "Uzbekistan",
        nativeName: "Ўзбекистон"
    },
    {
        countryCode: "VA",
        countryName: "Vatican City",
        nativeName: "Città del Vaticano"
    },
    {
        countryCode: "VE",
        countryName: "Venezuela",
        nativeName: "Wenesuera"
    },
    {
        countryCode: "VN",
        countryName: "Vietnam",
        nativeName: "Việt Nam"
    },
    {
        countryCode: "WF",
        countryName: "Wallis & Futuna",
        nativeName: "Wallis-et-Futuna"
    },
    {
        countryCode: "EH",
        countryName: "Western Sahara",
        nativeName: "الصحراء الغربية"
    },
    {
        countryCode: "YE",
        countryName: "Yemen",
        nativeName: "اليمن"
    }
];

export default countries;
